<section class="center">
  <img [src]="data?.imgPath || ''" />
  <h1>{{ data?.title || '' }}</h1>
  <p class="description">{{ data?.description || '' }}</p>
  <button nz-button [nzType]="data?.nzButtonType || 'primary'" (click)="data?.callback()">
    {{ data?.buttonText || 'Fechar' }}
  </button>
</section>
